import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import TemplateInstanceProvider from "../../../../Providers/TemplateInstanceProvider";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import PackageInstanceProvider, {
  ACTIONS_SET_ADDED_TO_CART,
  ACTIONS_SET_ADDING_TO_CART,
  editPackageForceSetSameSubject,
  usePackageInstance,
} from "../../../../Providers/PackageInstanceProvider";
import MobilePage from "../../../Components/MobilePage";
import AppBar from "../AppBar";
import EditPackage from "./EditPackage";
import GreenScreenBackgroundsProvider from "../../Providers/GreenScreenBackgroundsProvider";
import { usePictureSets } from "../../../hooks/usePictureSets";
import useRetouch from "@/react/Webshop/hooks/useRetouch";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import ProductRetouch from "@/react/Webshop/Mobile/Pages/ProductRetouch/ProductRetouch";

export default ({ orderLine }) => {
  return (
    <PackageInstanceProvider>
      <TemplateInstanceProvider>
        <Wrapper orderLine={orderLine} />
      </TemplateInstanceProvider>
    </PackageInstanceProvider>
  );
};

const Wrapper = ({ orderLine }) => {
  const history = useHistory();
  const { updateItem } = useShoppingCart();
  const { currentPictureSet, pictureSets, setCurrentPictureSet } =
    usePictureSets();
  const {
    state,
    initializeInstance,
    loading,
    dispatch: packageDispatch,
  } = usePackageInstance();
  const { getRetouchPicturesByOrderLines } = useRetouch();
  const { hasRetouchProduct } = usePriceList();
  const [retouchPictures, setRetouchPictures] = useState(null);

  useEffect(() => {
    // We require picturesets to be loaded in case we have to change subject
    if (!pictureSets) {
      return;
    }

    if (
      currentPictureSet?.subject?.uuid != orderLine.package.subject.uuid &&
      editPackageForceSetSameSubject(orderLine.package.allowSubjectChange)
    ) {
      const pictureSet = pictureSets.find(
        (p) => p.subject.uuid == orderLine.package.subject.uuid,
      );
      if (pictureSet) {
        setCurrentPictureSet(pictureSet);
      }
    }

    initializeInstance(orderLine.package);
  }, [pictureSets]);

  const handleUpdateCart = async () => {
    packageDispatch({
      type: ACTIONS_SET_ADDING_TO_CART,
      payload: {
        isAddingToCart: true,
      },
    });

    const updatedOrderLine = {
      ...orderLine,
      package: {
        ...orderLine.package,
        packageItems: state.packageItems,
      },
    };
    await updateItem(updatedOrderLine);
    packageDispatch({
      type: ACTIONS_SET_ADDED_TO_CART,
    });

    if (hasRetouchProduct) {
      const retouchPictures = getRetouchPicturesByOrderLines([
        updatedOrderLine,
      ]);

      if (retouchPictures.length > 0) {
        setRetouchPictures(retouchPictures);
        return;
      }
    }
    history.push("/shopping-cart/");
  };

  if (loading) {
    return <div>Loading</div>;
  }

  if (retouchPictures !== null) {
    return <ProductRetouch pictures={retouchPictures} />;
  }

  return (
    <MobilePage>
      <AppBar disableGutters={true} />
      <GreenScreenBackgroundsProvider jobUuid={currentPictureSet.job.uuid}>
        <EditPackage
          mode={"update"}
          orderLine={orderLine}
          handleUpdateCart={handleUpdateCart}
        />
      </GreenScreenBackgroundsProvider>
    </MobilePage>
  );
};
